import styled from "styled-components";

interface ProductItem {
  id: number;
  name: string;
  image: string;
  url: string;
  category: string;
  createdAt: string;
  updatedAt: string;
}

interface Props {
  data: ProductItem[];
}

const ProductList = ({ data }: Props) => {
  const onItemClicked = (item: ProductItem) => {
    window.open(item.url, "_blank");
  }
  return (
    <Container>
      {data.map((item: ProductItem, index: number) => (
        <ProductContainer key={index} onClick={() => onItemClicked(item)}>
          <Image src={item?.image} alt={item?.name} width={48} height={48} />
          <Text>{item?.name}</Text>
        </ProductContainer>
      ))}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 24px;
  margin-top: 24px;
`;

const ProductContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 24px;
  cursor: pointer;
`;

const Image = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 8px;
  margin-right: 10px;
`;
const Text = styled.span``;

export default ProductList;
